import React from 'react';
import { useSiteSettings } from '../../../hooks/useSiteSettings';
import { 
  CopyrightContainer, 
  CopyrightGrid, 
  LeftSection, 
  RightSection, 
  Divider, 
  ContactLink, 
  SignatureContainer, 
  SignatureLink 
} from './Copyright.styles';

import { FaLinkedin } from 'react-icons/fa';

export const Copyright = () => {
  const { settings } = useSiteSettings();
  
  if (!settings) return null;
  
  const { contact, footer } = settings;
  
  return (
    <CopyrightContainer>
      <CopyrightGrid>
        <LeftSection>
          <h3>İLETİŞİM</h3>
          {contact.address && (
            <p>
              <strong>Adres</strong>:{' '}
              {/* <ContactLink 
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${contact.address}, ${contact.city || ''}`)}`}
                target="_blank" 
                rel="noopener noreferrer"
              >
                {contact.address}
                {contact.city && ` / ${contact.city}`}
              </ContactLink> */}
              <span>
                {contact.address}
                {contact.city && ` / ${contact.city}`}
              </span>
            </p>
          )}
          {(contact.phone || contact.phone2) && (
            <p>
              <strong>Telefon:</strong>{' '}
              <span>
                {contact.phone && (
                  <ContactLink href={`tel:${contact.phone.replace(/[^0-9+]/g, '')}`}>
                    {contact.phone}
                  </ContactLink>
                )}
                {contact.phone && contact.phone2 && ' / '}
                {contact.phone2 && (
                  <ContactLink href={`tel:${contact.phone2.replace(/[^0-9+]/g, '')}`}>
                    {contact.phone2}
                  </ContactLink>
                )}
              </span>
            </p>
          )}
          {contact.landLine && (
            <p>
              <strong>Sabit Hat</strong>:{' '}
              <ContactLink href={`tel:${contact.landLine.replace(/[^0-9+]/g, '')}`}>
                {contact.landLine}
              </ContactLink>
            </p>
          )}
          {contact.email && (
            <p>
              <strong>E-Mail</strong>:{' '}
              <ContactLink href={`mailto:${contact.email}`}>
                {contact.email}
              </ContactLink>
            </p>
          )}
          {contact.workingHours && (
            <p>
              <strong>Çalışma Saatleri</strong>: {contact.workingHours}
            </p>
          )}
        </LeftSection>
        
        <Divider />
        
        <RightSection>
          {footer?.copyright && <p>{footer?.copyright}</p>}
          {footer?.description && <p>{footer?.description}</p>}
        </RightSection>
      </CopyrightGrid>
        {/* İmza Alanı */}
          <SignatureContainer>
            <span>Designed and Developed by</span>
            <SignatureLink 
              href="https://www.linkedin.com/in/sinan-sezer-b67b21176" 
              aria-label="LinkedIn Profile"
              className="linkedin"
            >
              <FaLinkedin />
              <span>Sinan SEZER</span>
            </SignatureLink>
          </SignatureContainer>
    </CopyrightContainer>
  );
};
